import axios from "./axios";
import {isObject} from "lodash";

export async function sendOrder(payload) {
    const data = new FormData()

    appendBilling()
    appendContact()
    appendCustomer()
    appendDeliveryType()
    appendItems()
    appendPaymentMethod()
    appendPromocode()
    appendRequisites()
    appendRequisitesFile()
    appendShipping()


    try {
        const response =  await axios.post(
            '/api/v1/orders',
            data,
            { headers: {
                    'Content-Type': 'multipart/form-data'}
            }
        )
        if(response?.status === 201) return response.data.data
        return null
    } catch (e) {
        return Promise.reject(e)
    }


    // ------------ helpers -------------------------------->

    function appendBilling() {
        data.append('billing[city_id]', payload?.billing?.city_id)
        data.append('billing[country_id]', payload?.billing?.country_id)
        data.append('billing[address1]', payload?.billing?.address1)
        data.append('billing[address2]', payload?.billing?.address2)
    }

    function appendContact() {
        data.append('contact[email]', payload?.contact?.email)
        data.append('contact[firstname]', payload?.contact?.firstname)
        data.append('contact[lastname]', payload?.contact?.lastname)
        data.append('contact[phone]', payload?.contact?.phone)
    }

    function appendCustomer() {
        data.append('customer[email]', payload?.customer?.email)
        data.append('customer[firstname]', payload?.customer?.firstname)
        data.append('customer[lastname]', payload?.customer?.lastname)
        data.append('customer[phone]', payload?.customer?.phone)
    }

    function appendDeliveryType() {
        data.append('delivery[type]', payload?.deliveryType?.type)
    }

    // {"item_id":6,"item_type":{"type":"catalog","id":6},"quantity":16}

    function appendItems() {
        if(Array.isArray(payload?.items)) {
            let index = 0
            for(const item of payload.items) {
                data.append(`items[${index}][item_id]`, item?.item_id)
                data.append(`items[${index}][item_type][id]`, item?.item_type?.id)
                data.append(`items[${index}][item_type][type]`, item?.item_type?.type)
                data.append(`items[${index}][quantity]`, item?.quantity)
                index++
            }
        }
    }

    function appendPaymentMethod() {
        data.append('payment_method', payload.payment_method)
    }
    function appendPromocode() {
        if(payload?.promocode !== null)
            data.append('promocode', payload.promocode)
    }

    function appendRequisites() {
        if(payload?.requisites !== null)
            data.append('requisites', JSON.stringify(payload.requisites))
    }

    function appendRequisitesFile() {
        if(payload?.requisites_file !== null)
            data.append('requisites_file', JSON.stringify(payload.requisites_file))
    }

    function appendShipping() {
        data.append('shipping[city_id]', payload?.shipping?.city_id)
        data.append('shipping[country_id]', payload?.shipping?.country_id)
        data.append('shipping[address1]', payload?.shipping?.address1)
        data.append('shipping[address2]', payload?.shipping?.address2)
    }
}

